import { SyntheticEvent } from 'react'
import { Flex, Text } from 'components/elements'
import { CSS } from 'theme'
import { ButtonShimmer } from 'components/shimmers'
import { TabWrap, TabsWrap } from 'components/tab/Styles'
import { TabItem } from 'config/types'
import { Tooltip } from '@mui/material'
import { SvgWrap } from 'components/svg'
import { LockIcon } from 'components/icons'

export type ColorProps = 'transparent' | 'primary'

interface DivisionTabsProps {
  css?: CSS
  items: TabItem[]
  loading?: boolean
  value: number
  color?: ColorProps
  handleChange: (event: SyntheticEvent, newValue: number) => void
  data?: unknown
}

export const TabItems = ({
  css,
  items,
  loading,
  value,
  color,
  handleChange,
  data,
}: DivisionTabsProps) => {
  return (
    <Flex css={{ ...css }}>
      {loading ? (
        Array(5)
          .fill(null)
          .map((_, index) => <ButtonShimmer key={`shimmer-${index}`} />)
      ) : (
        <>
          {value !== undefined ? (
            <TabsWrap
              value={value}
              onChange={handleChange}
              aria-label="wrapped label tabs example"
              color={color}
            >
              {items?.length &&
                items.map((item: TabItem, index: number) => (
                  <TabWrap
                    value={index} // Use the index as the value
                    label={
                      <>
                        {item.icon && <item.icon />}
                        {item.name}
                      </>
                    }
                    key={index}
                    disabled={item?.disabled}
                    icon={
                      item?.disabled ? (
                        <Tooltip
                          title={
                            <Text as="tooltip" color="white">
                              You don't have permission to access this.
                            </Text>
                          }
                          arrow
                          placement="top"
                        >
                          <Flex align={'center'}>
                            <SvgWrap color={'disabled'} size={'xxs'}>
                              <LockIcon />
                            </SvgWrap>
                          </Flex>
                        </Tooltip>
                      ) : undefined
                    }
                    iconPosition="end"
                  />
                ))}
            </TabsWrap>
          ) : null}
        </>
      )}
    </Flex>
  )
}
